import type { FeedbackOrigin } from "@productlane/db/browser"
import { FeedbackOriginTextRecord } from "@productlane/lib"

const CHART_ORIGIN_LABELS: Partial<Record<FeedbackOrigin, string>> = {
	INAPP: "In-app",
	PORTAL: "Portal",
	SUPPORT_PORTAL: "Support portal",
	SLACK_CONNECT: "Slack Connect",
	TEAMS: "Teams",
	INTERCOM_ATTACHMENT: "Intercom",
	ZENDESK_ATTACHMENT: "Zendesk",
	FRONT_ATTACHMENT: "Front",
}

const isFeedbackOrigin = (value: string): value is FeedbackOrigin =>
	value in FeedbackOriginTextRecord

export const formatReportingOrigin = (origin: string): string => {
	if (isFeedbackOrigin(origin)) {
		return CHART_ORIGIN_LABELS[origin] ?? FeedbackOriginTextRecord[origin]
	}
	return origin
		.toLowerCase()
		.split("_")
		.filter(Boolean)
		.map((part) => part.charAt(0).toUpperCase() + part.slice(1))
		.join(" ")
}
